import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: 'language-selector',
  class: "language-selector-container"
}
const _hoisted_2 = { href: "/account/settings" }

import { DropDownList as KDropDownList } from '@progress/kendo-vue-dropdowns';
import { computed, onBeforeMount, watch } from 'vue';
import { useAppStore } from '@/stores/app.store';
import { ref } from 'vue';
import useLocalization from '@/composables/useLocalization';
import { DropDownListChangeEvent } from '@progress/kendo-vue-dropdowns/dist/esm/DropDownList/DropDownListProps';
import LanguageSelectorItem from './LanguageSelectorItem.vue';
import { languageSelectorItemType } from './LanguageSelectorTypes';
import systemApiService from '@/services/system.api.service';
import { animationSetting } from '@/constants/globalKendoConfig';
import useTranslations from '@/composables/useTranslations';
import { useUserStore } from '@/stores/user.store';


export default /*@__PURE__*/_defineComponent({
  __name: 'LanguageSelector',
  setup(__props) {

const { translate: t } = useTranslations();
const { getCultureNameInItsOwnCulture, changeApplicationLanguage } = useLocalization();
const appStore = useAppStore();
const userStore = useUserStore();

const selectedLanguage = ref({});
const isLanguageChanging = ref(false);
const isConfigureTranslationsVisible = computed(
  () =>
    Object.keys(userStore.userSettings).length !== 0 &&
    appStore.systemSettings.isAutomaticTranslationServiceEnabled,
);

const cultureCodes = computed((): languageSelectorItemType[] => {
  return appStore?.cultureSettings?.visibleCultures?.map((element) => {
    return {
      cultureCode: element?.cultureCode,
      text: element?.cultureNameInItsOwnCulture,
      justify: element?.isRightToLeft ? 'right' : 'left',
    };
  });
});

const languageName = computed(() => {
  return getCultureNameInItsOwnCulture(appStore?.cultureCode);
});

async function onLanguageChange(ev: DropDownListChangeEvent) {
  const selectedLanguage: languageSelectorItemType = ev?.target?.value;
  if (selectedLanguage?.cultureCode) {
    isLanguageChanging.value = true;
    await systemApiService.changeLanguage(selectedLanguage?.cultureCode);
    changeApplicationLanguage(selectedLanguage?.cultureCode);
    isLanguageChanging.value = false;
    location.reload();
  }
}

function fetchSelectedLanguage() {
  if (appStore?.cultureCode) {
    selectedLanguage.value = {
      cultureCode: appStore?.cultureCode,
      text: languageName,
    };
  }
}

onBeforeMount(() => {
  fetchSelectedLanguage();
});

watch(
  () => appStore.cultureCode,
  async (newValue, oldValue) => {
    if (oldValue?.includes('-')) {
      window.location.reload();
    } else if (newValue) {
      fetchSelectedLanguage();
    }
  },
  { deep: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(KDropDownList), {
      ref: "languageSelectorRef",
      "data-items": cultureCodes.value,
      "text-field": 'text',
      "data-item-key": 'cultureCode',
      value: selectedLanguage.value,
      size: 'large',
      "item-render": LanguageSelectorItem,
      "class-name": 'language-selector',
      "popup-settings": {
        anchor: 'languageSelectorRef',
        appendTo: 'language-selector',
        className: 'popup-container language-selector__popup ',
        animate: _unref(animationSetting),
        popupClass: 'popup-list',
      },
      "fill-mode": 'outline',
      disabled: isLanguageChanging.value,
      "icon-class-name": 'cwx-icon cwx-icon-before_arrow-chevron-down',
      loading: isLanguageChanging.value,
      footer: isConfigureTranslationsVisible.value ? 'footer' : undefined,
      "aria-label": 'Language Selector',
      onChange: onLanguageChange
    }, {
      LanguageSelectorItemTemplate: _withCtx(({ props }) => [
        _createVNode(LanguageSelectorItem, {
          class: _normalizeClass('language-selector'),
          "data-item": props.dataItem,
          onClick: (ev) => props.onClick(ev)
        }, null, 8, ["data-item", "onClick"])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("a", _hoisted_2, _toDisplayString(_unref(t)('ConfigureTranslations')), 1)
      ]),
      _: 1
    }, 8, ["data-items", "value", "popup-settings", "disabled", "loading", "footer"])
  ]))
}
}

})